// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acp-filters .text-color {
  color: #003da5;
}

.warning-dialog.p-dialog {
  width: 58rem;
  height: 14rem;
  position: relative;
}
.warning-dialog.p-dialog .p-dialog-header .p-dialog-header-icons button {
  color: #595959;
}
.warning-dialog.p-dialog .p-dialog-header .p-dialog-header-icons button svg {
  width: 1rem;
  height: 1rem;
  font-weight: bold;
}
.warning-dialog.p-dialog div.p-dialog-contet {
  overflow-y: hidden !important;
}
.warning-dialog.p-dialog .p-dialog-header1 {
  font-size: 2rem;
  font-weight: bold;
}
.warning-dialog.p-dialog p {
  color: #003da5;
  font-weight: bold;
  padding-top: 10px;
  font-size: 1.7rem;
  padding-right: 2.5rem;
}
.warning-dialog.p-dialog .btn-wrapper {
  bottom: 2rem;
  right: 2.5rem;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: end;
}
.warning-dialog.p-dialog .btn-wrapper .btn-yes {
  width: 6rem;
  height: 2.7rem;
  color: #fff;
  font-weight: bold;
  margin-right: 1rem;
  border-radius: 1.5rem;
  background: #003da5;
  border: 0.2rem solid #003da5;
  padding: 0.4rem 1.6rem 0.4rem 1.6rem;
}
.warning-dialog.p-dialog .btn-wrapper .btn-no {
  width: 6rem;
  height: 2.7rem;
  color: #003da5;
  font-weight: bold;
  background: #fff;
  margin-right: 1rem;
  border-radius: 1.5rem;
  border: 0.2rem solid #003da5;
  padding: 0.4rem 1.6rem 0.4rem 1.6rem;
}

.acpCloseDialogSubContainer .p-dialog-content {
  display: flex;
  align-items: flex-end;
}

.excel-dw img:hover {
  cursor: pointer;
}

.overlay-loader {
  position: initial !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ACP/common/index.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;;AAIA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AADF;AAKM;EAOE,cAAA;AATR;AAGQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AADV;AASE;EACE,6BAAA;AAPJ;AAUE;EACE,eAAA;EACA,iBAAA;AARJ;AAWE;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AATJ;AAYE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAVJ;AAYI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,4BAAA;EACA,oCAAA;AAVN;AAaI;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oCAAA;AAXN;;AAiBE;EACE,aAAA;EACA,qBAAA;AAdJ;;AAmBI;EACE,eAAA;AAhBN;;AAsBA;EACE,4BAAA;AAnBF","sourcesContent":[".acp-filters {\n  .text-color {\n    color: #003da5;\n  }\n}\n\n.warning-dialog.p-dialog {\n  width: 58rem;\n  height: 14rem;\n  position: relative;\n\n  .p-dialog-header {\n    .p-dialog-header-icons {\n      button {\n        svg {\n          width: 1rem;\n          height: 1rem;\n          font-weight: bold;\n        }\n\n        color: #595959;\n      }\n    }\n  }\n\n  div.p-dialog-contet {\n    overflow-y: hidden !important;\n  }\n\n  .p-dialog-header1 {\n    font-size: 2rem;\n    font-weight: bold;\n  }\n\n  p {\n    color: #003da5;\n    font-weight: bold;\n    padding-top: 10px;\n    font-size: 1.7rem;\n    padding-right: 2.5rem;\n  }\n\n  .btn-wrapper {\n    bottom: 2rem;\n    right: 2.5rem;\n    display: flex;\n    position: absolute;\n    align-items: center;\n    justify-content: end;\n\n    .btn-yes {\n      width: 6rem;\n      height: 2.7rem;\n      color: #fff;\n      font-weight: bold;\n      margin-right: 1rem;\n      border-radius: 1.5rem;\n      background: #003da5;\n      border: 0.2rem solid #003da5;\n      padding: 0.4rem 1.6rem 0.4rem 1.6rem;\n    }\n\n    .btn-no {\n      width: 6rem;\n      height: 2.7rem;\n      color: #003da5;\n      font-weight: bold;\n      background: #fff;\n      margin-right: 1rem;\n      border-radius: 1.5rem;\n      border: 0.2rem solid #003da5;\n      padding: 0.4rem 1.6rem 0.4rem 1.6rem;\n    }\n  }\n}\n\n.acpCloseDialogSubContainer {\n  .p-dialog-content {\n    display: flex;\n    align-items: flex-end;\n  }\n}\n.excel-dw {\n  img {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n\n// AWM-3259 fix overlay position to set footer to bottom in manage capacity\n.overlay-loader {\n  position: initial !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
